module.exports = __webpack_public_path__ + "static/modern-928d99f9c9fd4a4f58fd515079c9144e.png";